import React from 'react';
import { useTranslation } from 'react-i18next';

import EmptyData from 'components/EmptyData';
import PoliciesItem from 'modules/Policies/components/PoliciesItem';
import { PoliciesSectionWrap } from 'modules/Policies/layout/Policies/PoliciesSection/styled';

import { IPoliciesItemModel } from '@common/models/Policies/PoliciesItem';

interface PropsType {
	policies: IPoliciesItemModel[];
}

function PoliciesSection({ policies }: PropsType) {
	const { t } = useTranslation();
	if (!policies || policies.length <= 0) {
		return <EmptyData title={t('policies.emptyDataTitle')} />;
	}

	return (
		<PoliciesSectionWrap>
			{policies.map((policiesItem) => (
				<PoliciesItem policiesItem={policiesItem} key={policiesItem.id} />
			))}
		</PoliciesSectionWrap>
	);
}

export default PoliciesSection;
